class SearchDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.searchButton = document.querySelector('.header__search');
    this.closeSearchButton = this.querySelector('.close-search-drawer-button');
    this.cartContainer = this.querySelector('.search-drawer__container');

    this.bindedHandleKeyUp = this.handleKeyUp.bind(this);
    this.bindedHandleClick = this.handleClick.bind(this);

    document.documentElement.style.setProperty("--search-drawer-width", `${this.cartContainer.clientWidth}px`);

    this.searchButton.addEventListener('click', this.bindedHandleClick);
    this.addEventListener('click', this.bindedHandleClick);

    this.addEventListener('keyup', this.bindedHandleKeyUp);

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        document.documentElement.style.setProperty("--search-drawer-width", `${entry.borderBoxSize[0].inlineSize}px`);
        this.cartContainer.style.transform = `translate(100%,${window.scrollY}px)`;
      }
    });
    this.resizeObserver.observe(this.cartContainer);
  }

  disconnectedCallback() {
    this.searchButton.removeEventListener('click', this.bindedHandleClick);
    this.removeEventListener('click', this.bindedHandleClick);
    this.removeEventListener('keyup', this.bindedHandleKeyUp);
    this.resizeObserver.disconnect();
  }

  handleKeyUp(event) {
    if (event.key !== 'Escape') return;

    this.close();
  }

  handleClick(event) {
    if (event.target.closest('.close-search-drawer-button') || !event.target.closest('.search-drawer__container')) {
      this.classList.contains('open')? this.close() : this.open();
    }
  }

  handleTransitionEnd() {
    this.querySelector('.search__input').focus();
  }

  open() {
    this.cartContainer.style.transform = `translate(100%,${window.scrollY}px)`;
    document.body.style.transform = 'translateX(calc(-1 * var(--search-drawer-width)))';
    this.classList.add('open');
    this.searchButton.setAttribute('aria-expanded', 'true');
    this.closeSearchButton.setAttribute('aria-expanded', 'true');

    this.addEventListener('transitionend', this.handleTransitionEnd.bind(this), {once: true})
  }

  close() {
    this.cartContainer.removeAttribute('style');
    document.body.removeAttribute('style');
    this.classList.remove('open');
    this.searchButton.setAttribute('aria-expanded', 'false');
    this.closeSearchButton.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('search-drawer', SearchDrawer);
